import type { Category } from "@/types/content";

export const categories: Category[] = [
  {
    slug: "star",
    name: "明星动态",
    desc: "台前幕后的最新动向，从官宣到日常，第一手了解他们最近在忙什么。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20entertainment%20magazine%20abstract%20collage%20of%20spotlight%20and%20stage%20silhouette%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=900&height=700&seq=cat-star-2026&orientation=landscape",
    emoji: "ri-star-smile-line",
  },
  {
    slug: "film",
    name: "影视追踪",
    desc: "新片点映、剧集口碑、幕后创作，帮你在进场前先看一眼值不值得。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20cinema%20abstract%20collage%20of%20film%20reel%20and%20screening%20light%20beam%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=900&height=700&seq=cat-film-2026&orientation=landscape",
    emoji: "ri-film-line",
  },
  {
    slug: "variety",
    name: "综艺看点",
    desc: "从竞技到慢综艺，拆解节目为什么好看，也聊聊它为什么让人追下去。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20tv%20show%20abstract%20collage%20of%20stage%20lights%20and%20microphone%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=900&height=700&seq=cat-variety-2026&orientation=landscape",
    emoji: "ri-mic-line",
  },
  {
    slug: "music",
    name: "音乐现场",
    desc: "新歌、巡演与 Livehouse 现场，记录音乐在耳机之外真实发生的样子。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20music%20abstract%20collage%20of%20sound%20waves%20and%20guitar%20strings%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=900&height=700&seq=cat-music-2026&orientation=landscape",
    emoji: "ri-music-2-line",
  },
  {
    slug: "fashion",
    name: "时尚风向",
    desc: "秀场、红毯与日常穿搭，把趋势翻译成衣柜里真的能穿出门的那种。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20fashion%20abstract%20collage%20of%20fabric%20folds%20and%20design%20sketch%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=900&height=700&seq=cat-fashion-2026&orientation=landscape",
    emoji: "ri-t-shirt-line",
  },
  {
    slug: "overseas",
    name: "海外娱乐",
    desc: "海外剧集、综艺与颁奖季，用最快的方式补齐时差里的那些热闹。",
    cover:
      "https://readdy.ai/api/search-image?query=editorial%20global%20entertainment%20abstract%20collage%20of%20globe%20and%20neon%20marquee%2C%20coral%20red%20and%20golden%20amber%20shapes%20on%20warm%20cream%20paper%20background%2C%20stylized%20geometric%20soft%20grain%20minimal%20flat%20illustration%2C%20no%20text&width=900&height=700&seq=cat-overseas-2026&orientation=landscape",
    emoji: "ri-global-line",
  },
];